import './styles.css';
import { Position } from 'react-pdf-highlighter';

const HighlightZoom = ({
  animated,
  src,
  position,
}: {
  animated: boolean;
  src: string;
  position: Position;
}) => {
  return (
    <div
      style={{
        left: position.boundingRect.left,
        top: position.boundingRect.top,
        zIndex: 1002
      }}
      className={`highlightZoom ${animated ? 'animate' : ''}`}
    >
      <img src={src} alt="" />
    </div>
  );
};

export default HighlightZoom;
